module.exports = __webpack_public_path__ + "static/media/White.a5b359d3.svg";